import * as S from "./AuthTemplate.style";

interface AuthProps {
  children?: React.ReactElement;
}

export const AuthTemplate = ({ children }: AuthProps) => {
  return <S.AuthTemplate>{children}</S.AuthTemplate>;
};
